import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  getAssetDetailById,
  getAssetPaymentDetailById,
  getAssetPaymentsListItems,
  getAssetPaymentsCommissionDetailById,
  getAssetPaymentsCommissionsListItems,
} from "../../../../redux/Case/assetSlice";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import { Label, Toaster } from "@fluentui/react-components";
import { makeStyles, tokens } from "@fluentui/react-components";
import CaseDetailDrawer from "../CaseDetailDrawer";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function AssetPaymentCommissions({ tab }: { tab?: string }) {
  const styles = useStyles();
  const navigate = useNavigate();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, case_type, action, caseId, subItemId, subSubItemId } =
    useParams();
  const dispatch: AppDispatch = useDispatch();
  const assets = useSelector((state: RootState) => state.assets);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const caseType = case_type || "";
  const [activeTab, setActiveTab] = useState<string>(tab || "commission");
  const [isOpen, setIsOpen] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(1);

  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId && subItemId) {
      dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
      dispatch(getAssetPaymentDetailById(subItemId));
      dispatch(
        getAssetPaymentsCommissionsListItems({
          paymentId: subItemId,
          caseId,
          customerId: clientId,
        })
      );
    }
  }, [caseId, clientId, subItemId, dispatch, assets.payments.listItems]);

  useEffect(() => {
    if (subItemId && assets.payments.listItems.length > 0) {
      dispatch(getAssetPaymentDetailById(subItemId));
    }
  }, [subItemId, activeTab, assets.payments.listItems, dispatch]);

  useEffect(() => {
    if (subSubItemId && assets?.payments?.commissions?.listItems.length > 0) {
      dispatch(getAssetPaymentsCommissionDetailById(subSubItemId));
    }
  }, [
    subSubItemId,
    activeTab,
    assets.payments.commissions.listItems,
    dispatch,
  ]);

  const paymentId =
    subItemId || assets.payments.listItems[0]?.payment?.payment_id;
  const commissionId =
    subSubItemId || assets.payments?.commissions?.listItems[0]?.commission_id;

  useEffect(() => {
    if (!caseId || !paymentId || !commissionId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/view`
      );
    } else if (action === "add") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/payments/${paymentId}/commission/add`
      );
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/assets/${case_type}/${caseId}/payments/${paymentId}/commission/${commissionId}/commission/view`
      );
    }
  }, [
    action,
    clientId,
    case_type,
    tab,
    caseId,
    paymentId,
    commissionId,
    assets.payments.commissions.listItems,
    navigate,
  ]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />

      <CaseNavList
        subItem="payments"
        section="assets"
        tab={activeTab}
        caseType={caseType}
        caseDetail={assets.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        <CaseForm
          mode={action || ""}
          section="assets"
          caseType={caseType}
          caseDetail={assets.payments.commissions.activeItem}
          caseItemList={assets.payments.commissions.listItems}
          tab={activeTab}
          subItem="payments"
          notify={showToast}
          currentRecord={currentRecord}
          setCurrentRecord={setCurrentRecord}
        />

        <div>
          {assets?.payments.commissions.loading ? (
            <ContentLoader />
          ) : (
            <>
              {assets?.payments.commissions.listItems.length > 0 && (
                <CaseList
                  module="commission"
                  data={assets?.payments.commissions.listItems}
                  activeItem={assets?.payments.commissions.activeItem}
                  section="assets"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action &&
                assets?.payments.commissions.listItems.length === 0 && (
                  <NoDataFound />
                )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={assets?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default AssetPaymentCommissions;
